<template>
  <div>
    <el-select
        v-model="warehouseId"
        :style="{width: width}"
        placeholder="请选择所在仓库"
        clearable
        filterable
    >
      <el-option
          v-for="item in warehouseList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      />
    </el-select>
    <el-select
        v-model="selectedValue"
        :style="{width: width}"
        placeholder="请选择物料"
        clearable
        filterable
    >
      <el-option
          v-for="item in getSelectedValue()"
          :disabled="!warehouseId"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'MaterialLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      materialList: [],
      selectedValue: null,
      warehouseId: null,
      warehouseList: []
    }
  },
  watch: {
    selectedValue(newVal) {
      this.selectedValue = newVal
      const selectedMaterial = this.materialList?.find(item => item.id === newVal);
      console.log('selectedMaterial', newVal,selectedMaterial)
      console.log("materialList",this.materialList)
      if(selectedMaterial){
        this.$emit('callBack', {
          id: selectedMaterial?.id,
          name: selectedMaterial?.name
        });
        this.warehouseId = selectedMaterial.warehouseId
      }
    },
    value(newVal) {
      if(newVal && newVal !== this.selectedValue){
        this.selectedValue = newVal
      }
    }
  },
  async mounted() {
    await this.fetchMaterialList()
    this.selectedValue = this.value
  },
  methods: {
    async fetchMaterialList() {
      try {
        const res = await requestTicket.post('/Ticketing/material/findAll')
        this.materialList = res.data || []
      } catch (error) {
        console.error('获取物料列表失败:', error)
      }
      try {
        const resWarehouse = await requestTicket.post('/Ticketing/warehouse/findAll')
        this.warehouseList = resWarehouse.data || []
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    getSelectedValue() {
      console.log('this.warehouseId',this.warehouseId,this.materialList)
      return this.materialList.filter(item => {
        return (this.warehouseId && item.warehouseId === this.warehouseId) || (!this.warehouseId && !item.warehouseId)
      })
    }
  }
}
</script>